import {
    Canvas,
    CanvasSource,
    Collaboration,
    Comment,
    Geometry,
    Participant,
    TagName,
    Update,
    Upload,
} from '@range.io/basic-types'
import { applyMiddleware, compose, createStore as reduxCreateStore } from 'redux'
import thunk from 'redux-thunk'
import { addResource } from '../firebase/commands-2/resources.js'
import logStateMiddleware from './log-state-middleware.js'
import { reduxReducer } from './redux-actions.js'

const createStore = () => {
    const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose

    const middlewares = [thunk.default ? thunk.default : thunk]
    if (typeof window !== 'undefined' && window.location.host.match(/localhost|127.0.0.1/)) {
        const message = `    Redux logging will track changes to keys you set; eg. window.reduxKeysToWatch = ['selectedUserId', 'organizations']`
        console.log(message)
        middlewares.push(logStateMiddleware)
    }

    const store = reduxCreateStore(reduxReducer, composeEnhancers(applyMiddleware(...middlewares)))
    addResource('dispatch', store.dispatch)
    addResource('getState', store.getState)

    // prettier-ignore
    const reduxBindState = getState => {
        
        /*
         * Add a new property to a (tagged) Type's prototype, without the need to get the current state
         */
        const defineGetter = (Type, propertyName, thunk) => {
            Object.defineProperty(Type.prototype, propertyName, {
                get() {
                    return thunk(this)
                },
            })
        }
        
        /*
         * Rename an existing (incorrectly-named) property to a new correct name, but yell about it
         */
        const defineGetterButComplain = (Type, oldPropertyName, newPropertyName) => {
            defineGetter(Type, oldPropertyName, _this => {
                console.error(`Rename ${Type}.${oldPropertyName} to ${Type}.${newPropertyName}`)
                return _this[newPropertyName]
            })
        }
        
        Canvas.extendForRedux(getState, defineGetter, defineGetterButComplain)
        CanvasSource.extendForRedux(getState, defineGetter, defineGetterButComplain)
        Collaboration.extendForRedux(getState, defineGetter, defineGetterButComplain)
        Comment.extendForRedux(getState, defineGetter, defineGetterButComplain)
        Geometry.extendForRedux(getState, defineGetter, defineGetterButComplain)
        Participant.extendForRedux(getState, defineGetter, defineGetterButComplain)
        TagName.extendForRedux(getState, defineGetter, defineGetterButComplain)
        Update.extendForRedux(getState, defineGetter, defineGetterButComplain)
        Upload.extendForRedux(getState, defineGetter, defineGetterButComplain)
    }

    reduxBindState(store.getState)

    return store
}

export default createStore
